import { render, staticRenderFns } from "./stationClamp_PLC.vue?vue&type=template&id=79d276e2&scoped=true"
import script from "./stationClamp_PLC.vue?vue&type=script&lang=js"
export * from "./stationClamp_PLC.vue?vue&type=script&lang=js"
import style0 from "./stationClamp_PLC.vue?vue&type=style&index=0&id=79d276e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d276e2",
  null
  
)

export default component.exports